export const FETCH_TENANT_CONFIG = 'tenant/FETCH_CONFIG';
export const FETCH_TENANT_CONFIG_SUCCESS = 'tenant/FETCH_CONFIG_SUCCESS';
export const FETCH_TENANT_CONFIG_FAILURE = 'tenant/FETCH_CONFIG_FAILURE';
export const SET_CLIENT_ASSETS = 'tenant/SET_CLIENT_ASSETS';
